var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1D2B4B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1D2B4B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1D2B4B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1D2B4B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1D2B4B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1D2B4B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDots);
export default ForwardRef;